import { type PropsWithChildren, useEffect, useRef } from "react";
import { useQueryClient } from "@-/com.npmjs.tanstack__react-query";
import { withDeadline } from "@-/dev.improve.haniverse.lib.deadline";
import { logger } from "@-/dev.improve.haniverse.lib.logger";
import { StaticDatabaseContext } from "#static-database-context";
import { useStaticDatabaseContextValue } from "#static-database-context-value";

export function StaticDatabaseContextProvider({ children }: PropsWithChildren) {
  const value = useStaticDatabaseContextValue();
  const client = useQueryClient();
  const previous = useRef(value.dataIdentity);
  useEffect(() => {
    if (previous.current === value.dataIdentity) {
      return;
    }
    previous.current = value.dataIdentity;
    // Content reads that predate dataIdentity must also re-run when reachability or files change.
    void withDeadline({ deadline: 30_000, operation: "activate downloaded content" }, () =>
      client.resetQueries({ predicate: (query) => query.queryKey[0] !== "level-pack-catalog" }),
    ).catch((error) => logger(import.meta.location).error(error));
  }, [client, value.dataIdentity]);
  return <StaticDatabaseContext.Provider value={value}>{children}</StaticDatabaseContext.Provider>;
}
